import React, { useEffect, useState, useCallback, useRef } from "react";
import { withRouter } from "react-router-dom";
import { UserCard } from "./UserCard";
import { Col, Row, Spinner, Form } from "react-bootstrap";
import "./User.scss";
import { DeleteModal } from "../Modals/DeleteModal";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentUserData,
  userList,
  updateProfile,
} from "../../../redux/actions/dbactions/profileActions";
import { Header } from "../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";

const User = ({ searchQuery }) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedUId, setSelectedUId] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("N");
  const [searchEmail, setSearchEmail] = useState("");
  const [page, setPage] = useState(1);
  const observer = useRef();
  const { user, isLoading } = useSelector((state) => state.user || {});
  const [users, setUsers] = useState([]);

  useEffect(() => {
    if (user?.usr?.data) {
      setUsers((prevUsers) => [...prevUsers, ...user.usr.data]);
    }
  }, [user]);

  useEffect(() => {
    dispatch(userList(page));
  }, [dispatch, page]);

  const lastUserRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting && user?.usr?.data?.length > 0) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [isLoading, user]
  );

  const handleShow = (uid, id, firstName, lastName, statusYN) => {
    setShow(true);
    setSelectedId(id);
    setSelectedUId(uid);
    setSelectedTitle(`${firstName} ${lastName}`);
    setSelectedStatus(statusYN === "Y" ? "N" : "R");
  };

  const handleEditModal = (data) => {
    dispatch(setCurrentUserData(data));
  };

  const handleDelete = () => {
    dispatch(
      updateProfile(
        {
          sys_active_yn: selectedStatus,
          sys_user_id: selectedId,
          user_id: selectedUId,
        },
        selectedId
      )
    );
    setShow(false);
  };

  const filteredUsers = users.filter((item) =>
    item.user_email.toLowerCase().includes(searchEmail.toLowerCase())
  );

  return (
    <div>
      <Header pageTitle="User List" icon={<Icon icon="fa-solid:user" />} />
      <div className="ser_title_b sm:!px-8 !px-3 mt-4 xs:!flex-row flex-col">
        <h5 className="title">My User List</h5>
      </div>

      <div className="search-bar-container mt-3 mb-3">
        <Form.Control
          type="text"
          placeholder="Search by email..."
          value={searchEmail}
          onChange={(e) => setSearchEmail(e.target.value)}
          className="search-bar"
        />
      </div>

      {isLoading && filteredUsers?.length === 0 ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <Row className="sm:px-4 m-0">
          {filteredUsers && filteredUsers.length > 0 ? (
            filteredUsers.map((item, index) => {
              if (index === filteredUsers.length - 1) {
                return (
                  <Col
                    ref={lastUserRef}
                    className="mb-3"
                    lg={4}
                    md={6}
                    key={item.user_id}
                  >
                    <UserCard
                      data={item}
                      searchQuery={searchQuery}
                      handleShow={() =>
                        handleShow(
                          item.user_id,
                          item.user_profile_id,
                          item.user_first_name,
                          item.user_last_name,
                          item.sys_active_yn
                        )
                      }
                      handleEditModal={() => handleEditModal(item)}
                    />
                  </Col>
                );
              }
              return (
                <Col className="mb-3" lg={4} md={6} key={item.user_id}>
                  <UserCard
                    data={item}
                    searchQuery={searchQuery}
                    handleShow={() =>
                      handleShow(
                        item.user_id,
                        item.user_profile_id,
                        item.user_first_name,
                        item.user_last_name,
                        item.sys_active_yn
                      )
                    }
                    handleEditModal={() => handleEditModal(item)}
                  />
                </Col>
              );
            })
          ) : (
            <Col>
              <p className="text-center">No users found</p>
            </Col>
          )}
          {isLoading && (
            <Col className="text-center">
              <Spinner animation="border" variant="primary" />
            </Col>
          )}
        </Row>
      )}
      <DeleteModal
        handleDelete={() => handleDelete(selectedId)}
        show={show}
        handleClose={() => setShow(false)}
        selectedTitle={selectedTitle}
        selectedId={selectedId}
        selectedStatus={selectedStatus}
      />
    </div>
  );
};

export default withRouter(User);
